export const countryDropdownOption = function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      callback: '&',
      label: '@',
      extraClass: '@',
      country: '@',
      disabled: '<'
    },
    template: "<li><button class='standard {{extraClass}}' ng-click='callback()' tabindex='1' ng-disabled='disabled'><flag country='{{country.toLowerCase()}}' size='16'></flag>{{::label}}</button></li>"
  };
};
